/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GetNumberFactsQuestionsR200ResponseQuestionsInnerKeyboardTypeEnum = {
    FiveKey: 'numeric_five_key',
    TenKey: 'numeric_ten_key',
    TwentyKey: 'numeric_twenty_key'
};
/**
 * @export
 */
export const GetNumberFactsQuestionsR200ResponseQuestionsInnerOperatorEnum = {
    Addition: 'addition',
    Subtraction: 'subtraction'
};
/**
 * @export
 */
export const GetNumberFactsQuestionsR200ResponseQuestionsInnerQuestionTypeEnum = {
    HorizontalTenFrame: 'horizontal_ten_frame',
    VerticalTenFrame: 'vertical_ten_frame',
    HorizontalNumber: 'horizontal_number',
    VerticalNumber: 'vertical_number',
    PictureOnly: 'picture_only'
};
/**
 * Check if a given object implements the GetNumberFactsQuestionsR200ResponseQuestionsInner interface.
 */
export function instanceOfGetNumberFactsQuestionsR200ResponseQuestionsInner(value) {
    if (!('correctAnswer' in value) || value['correctAnswer'] === undefined)
        return false;
    if (!('keyboardType' in value) || value['keyboardType'] === undefined)
        return false;
    if (!('leftOperand' in value) || value['leftOperand'] === undefined)
        return false;
    if (!('operator' in value) || value['operator'] === undefined)
        return false;
    if (!('questionType' in value) || value['questionType'] === undefined)
        return false;
    if (!('rightOperand' in value) || value['rightOperand'] === undefined)
        return false;
    return true;
}
export function GetNumberFactsQuestionsR200ResponseQuestionsInnerFromJSON(json) {
    return GetNumberFactsQuestionsR200ResponseQuestionsInnerFromJSONTyped(json, false);
}
export function GetNumberFactsQuestionsR200ResponseQuestionsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'correctAnswer': json['correctAnswer'],
        'keyboardType': json['keyboardType'],
        'leftOperand': json['leftOperand'],
        'operator': json['operator'],
        'questionType': json['questionType'],
        'rightOperand': json['rightOperand'],
    };
}
export function GetNumberFactsQuestionsR200ResponseQuestionsInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'correctAnswer': value['correctAnswer'],
        'keyboardType': value['keyboardType'],
        'leftOperand': value['leftOperand'],
        'operator': value['operator'],
        'questionType': value['questionType'],
        'rightOperand': value['rightOperand'],
    };
}
